module.exports = __webpack_public_path__ + "public/img/tuliyi.73d1c034.png";